import { filterNotEmpty } from '@beeline.com/bp-design-system';
import { excludeNotifications } from 'common/header/notifications/hooks/mappers/excludeNotifications';
import { auditReportMapper } from 'common/header/notifications/hooks/mappers/impl/auditReportMapper';
import { globalIdRunMapper } from 'common/header/notifications/hooks/mappers/impl/globalIdRunMapper';
import { importMapper } from 'common/header/notifications/hooks/mappers/impl/importMapper';
import { importUciMapper } from 'common/header/notifications/hooks/mappers/impl/importUciMapper';
import { importUserMapper } from 'common/header/notifications/hooks/mappers/impl/importUserMapper';
import { pingMapper } from 'common/header/notifications/hooks/mappers/impl/pingMapper';
import { supplierRelationshipChangeMapper } from 'common/header/notifications/hooks/mappers/impl/supplierRelationshipChangeMapper';
import { taskAssignedMapper } from 'common/header/notifications/hooks/mappers/impl/taskAssignedMapper';
import { taskResolvedMapper } from 'common/header/notifications/hooks/mappers/impl/taskResolvedMapper';
import { workdayOrgSyncMapper } from 'common/header/notifications/hooks/mappers/impl/workdayOrgSyncMapper';
import { workflowNotificationMapper } from 'common/header/notifications/hooks/mappers/impl/workflowNotificationMapper';
import type {
  MappedNotification,
  NotificationMapper,
  NotificationMapperOptions
} from 'common/header/notifications/Notifications.types';
import { NotificationTypeModel } from 'src/graphql/types';
import { csvExcelExportMapper } from './impl/csvExcelExportMapper';
import { coreMapper } from './impl/coreMapper';
import { Notification } from 'providers/Notifications/Notifications.types';

const NOTIFICATION_MAPPINGS = new Map<NotificationTypeModel, NotificationMapper>([
  [NotificationTypeModel.CsvExport, csvExcelExportMapper],
  [NotificationTypeModel.ExcelExport, csvExcelExportMapper],
  [NotificationTypeModel.Import, importMapper],
  [NotificationTypeModel.PersonEventImport, importMapper],
  [NotificationTypeModel.ImportUci, importUciMapper],
  [NotificationTypeModel.UserImport, importUserMapper],
  [NotificationTypeModel.WorkdayOrgTreeSync, workdayOrgSyncMapper],
  [NotificationTypeModel.Ping, pingMapper],
  [NotificationTypeModel.GlobalIdRun, globalIdRunMapper],
  [NotificationTypeModel.TaskAssigned, taskAssignedMapper],
  [NotificationTypeModel.TaskResolved, taskResolvedMapper],
  [NotificationTypeModel.SupplierRelationshipChange, supplierRelationshipChangeMapper],
  [NotificationTypeModel.AuditReport, auditReportMapper],
  [NotificationTypeModel.WorkflowNotification, workflowNotificationMapper]
]);

function mapNotification(
  notification: MappedNotification,
  options: NotificationMapperOptions
): MappedNotification | null {
  if (!notification.type) {
    return null;
  }
  return NOTIFICATION_MAPPINGS.get(notification.type)?.(notification, options) ?? null;
}

export function mapNotifications(
  notifications: Notification[],
  options: NotificationMapperOptions
): MappedNotification[] {
  return filterNotEmpty(
    notifications.filter(excludeNotifications).map((notification) => mapNotification(coreMapper(notification), options))
  );
}
